import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Product } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDealProductQuery(
	guid: string | undefined,
	options?: Omit<UseQueryOptions<Product, unknown, Product>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Product(guid),
		() => AxiosUtils.getResponseData<Product>(api.get(CerebroApiEndpoints.Product(guid))),
		options
	);
}
